import { apiHelpers } from "global/viewSettings/importing/apiHelpers"

export const fsfn_api = (fsCall) => {
  return {
    handleGolfCourseSearch: (fn_cls, courseName) => getForGolfCourse(fsCall, fn_cls, courseName),
    handleUrlSearch: (url) => handleUrlSearch(fsCall, url),
    handleHotelSearch: (url) => handleHotelSearch(fsCall, url),
    handleGhinSearch: () => handleGhinSearch(fsCall, courseName),
  }
}

const getForGolfCourse = (fsCall, fn_cls, courseName) => {
  apiHelpers.getScorecard(fn_cls, courseName).then(apiResult => {
    return ({ apiResult })
  })
}

const handleUrlSearch = (fsCall, url) => {
  apiHelpers.getUrlData(fsCall, url).then(apiResult => {
    return ({ apiResult })
  })
}

const handleHotelSearch = (fsCall, url) => {
  apiHelpers.getUrlData(fsCall, url).then(apiResult => {
    return ({ apiResult })
  })
}

const handleGhinSearch = (fsCall, golferNumber, golferClub) => {
  apiHelpers.getGhinCard(fsCall, golferNumber, golferClub).then(apiResult => {
    return ({ apiResult })
  })
} 